import { Staff } from "./Staff";
export class CandidateInvited {
  CandID;
  JobAdCode;
  Seq;
  CompCode;
  InterviewSch;
  Opt1;
  Opt2;
  Opt3;
  CallBack;
  DateInput;
  Interviewer;
  UsedExisting;
  StaffModel;
  IsNew;
  AttachmentList;
  IsInvitation;
  IsConfirmed;
  UserName;
  UserId;
  Password;
  CompanyEngName;
  CompanyChiName;
  JobName;
  constructor() {
    this.CandID = "";
    this.JobAdCode = "";
    this.Seq =0;
    this.CompCode = "";
    this.InterviewSch = new Date('1900-01-01');
    this.Opt1=new Date('1900-01-01');
    this.Opt2=new Date('1900-01-01');
    this.Opt3=new Date('1900-01-01');
    this.CallBack = false;
    this.DateInput = new Date('1900-01-01');
    this.Interviewer = "";
    this.UsedExisting = false;
    this.IsNew=false;
    this.StaffModel = new Staff();
    this.AttachmentList = [];
    this.IsInvitation = false;
    this.IsConfirmed = false;
    this.UserName = "";
    this.UserId = "";
    this.Password = "";
    this.CompanyEngName = "";
    this.CompanyChiName = "";
    this.JobName = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/CandidateInvited.js